module.exports = __webpack_public_path__ + "assets/img/user.62d5d45a.svg";